// extracted by mini-css-extract-plugin
export default {"fs9":"Cart_fs9__x9gxS","fs10":"Cart_fs10__OA3dT","pad":"Cart_pad__5LfsU"};